// src/modules/auth/services/requestCode.ts

import { sendRequest } from "../../../utils/request.ts";
import { showToast } from "../../../utils/toast.tsx";
import { VerifyCodeForm } from "../ui/VerifyCodeForm.tsx";

interface Params {
  event: SubmitEvent;
}

export const requestCode = async ({ event }: Params) => {
  event.preventDefault();

  const data = new FormData(event.target as HTMLFormElement);
  const email = data.get("email");
  if (typeof email !== "string") {
    showToast({ variant: "error", message: "Podaj adres email" });
    return;
  }

  await sendRequest({
    request: {
      url: "/api/auth/request-code",
      method: "POST",
      body: { email },
    },
    submitButton: {
      button: event.submitter as HTMLButtonElement,
      text: "Zaloguj",
    },
    errorMessage: "Podany adres email jest nieprawidłowy.",
    onSuccess: () => {
      const main = document.querySelector("main")!;
      main.innerHTML = "";
      main.appendChild(VerifyCodeForm({ email }));
    },
  });
};
